<template>
  <span>{{ fechaAlta }}</span>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  name: "DeudaActualComponent",
  computed: {
    fechaAlta() {
      if (this.params.data.fecha_alta) {
        const fechaDeAlta = this.params.data.fecha_alta;
        return this.$moment(fechaDeAlta).format("LL");
      }
      return "";
    },
  },
});
</script>

<style scoped></style>
